'use client';

import { useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

const QUICK_MENU_COUNT_TEXT = {
  giftProductCount: (count: string) => `${count}개 답례품`,
  institutionCount: (count: string) => `전국 ${count}개 지역`,
  recruitingGiftTrialCampaignCount: (count: string) => `${count}건 모집중`,
};

export type QuickMenuCountField = keyof typeof QUICK_MENU_COUNT_TEXT;

export const QuickMenuCount = ({ field }: { field: QuickMenuCountField }) => {
  //* BE가 1분 캐시라 그보다 자주 다시 받을 이유가 없다
  const { data: count } = useQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home-love/main/quick-menu-count'
    ](),
    staleTime: 60 * 1000,
    select: (data) => data.context?.[field],
  });

  return QUICK_MENU_COUNT_TEXT[field](count?.toLocaleString('ko-KR') ?? '-');
};
